const KNOWN_ACCOUNT_DOMAINS: Record<string, string> = {
	'app.thebigbash.de': 'the-big-bash',
	'demo-tbb.yannik-h.com': 'the-big-bash',
	'localhost': 'the-big-bash',
	'127.0.0.1': 'the-big-bash',
};

export function resolveAccountSlugFromHostname(hostname: string): string | null {
	return KNOWN_ACCOUNT_DOMAINS[hostname] ?? null;
}
